<script>
import NavBar from "@/components/nav-bar";
import RightBar from "@/components/right-bar";
import Footer from "@/components/footer";
import { menuItems } from "../config/menu";
import _ from "lodash";

export default {
  watch: {
    $route: {
      handler: "onRoutechange",
      immediate: true,
      deep: true,
    },
  },
  computed: {
    menus() {
        return this.$store ? this._getMenus(this.$store.state.permission.code) : [];
      // return menuItems;
    },
  },
  methods: {
    _getMenus(permission) {
      const _menuItems = _.cloneDeep(menuItems);
      let getMenus = null;
      const menus = (getMenus = (menus) => {
        return menus.filter((item) => {
          if (item.subItems) {
            item.subItems = getMenus(item.subItems);
            return item.subItems.length > 0;
          } else {
            return (
                !item.permCode ||
                (permission && permission.includes(item.permCode))
            );
          }
        });
      })(_menuItems);
      return menus;
    },
    onRoutechange(ele) {
      this.initActiveMenu(ele.path);
      localStorage.setItem('statistics_id','')
    },
    initActiveMenu(ele) {
      setTimeout(() => {
        if (document.querySelector("#navbar-nav")) {
          let a = document
              .querySelector("#navbar-nav")
              .querySelector('[href="' + ele + '"]');

          if (a) {
            a.classList.add("active");
            let parentCollapseDiv = a.closest(".collapse.menu-dropdown");
            if (parentCollapseDiv) {
              parentCollapseDiv.classList.add("show");
              parentCollapseDiv.parentElement.children[0].classList.add(
                  "active"
              );
              parentCollapseDiv.parentElement.children[0].setAttribute(
                  "aria-expanded",
                  "true"
              );
              if (
                  parentCollapseDiv.parentElement.closest(
                      ".collapse.menu-dropdown"
                  )
              ) {
                parentCollapseDiv.parentElement
                    .closest(".collapse")
                    .classList.add("show");
                if (
                    parentCollapseDiv.parentElement.closest(".collapse")
                        .previousElementSibling
                )
                  parentCollapseDiv.parentElement
                      .closest(".collapse")
                      .previousElementSibling.classList.add("active");
              }
            }
          }
        }
      }, 500);
    },
  },
  components: {
    NavBar,
    RightBar,
    Footer,
  },
};
</script>

<template>
  <div>
    <div id="layout-wrapper">
      <NavBar />
      <!-- ========== App Menu ========== -->
      <div class="app-menu navbar-menu" style="z-index: 1900">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <!-- Dark Logo-->
          <router-link to="/" class="logo logo-dark">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-dark.png" alt="" height="17" />
            </span>
          </router-link>
          <!-- Light Logo-->
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/logo-sm.png" alt="" height="22" />
            </span>
            <span class="logo-lg">
              <img src="@/assets/images/logo-light.png" alt="" height="17" />
            </span>
          </router-link>
          <button
              type="button"
              class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
              id="vertical-hover"
          >
            <i class="ri-record-circle-line"></i>
          </button>
        </div>
        <div id="scrollbar">
          <b-container fluid>
            <ul class="navbar-nav h-100 w-100 d-flex" style="z-index: 1900" id="navbar-nav">
              <li class="menu-title">
                <span data-key="t-menu"> {{ $t("t-menu") }}</span>
              </li>
              <template v-for="item in menus">
                <li v-if="item.subItems" class="nav-item" :key="item.id">
                  <b-link
                      class="nav-link menu-link"
                      :href="`#sidebar-${item.id}`"
                      data-bs-toggle="collapse"
                      role="button"
                      aria-expanded="false"
                      :aria-controls="`sidebar-${item.id}`"
                      style="white-space: nowrap"
                  >
                    <i :class="item.icon&&item.icon"></i>
                    <span > {{ $t(item.label) }}</span>
                  </b-link>
                  <div
                      class="collapse menu-dropdown"
                      :id="`sidebar-${item.id}`"
                  >
                    <ul class="nav nav-sm flex-column">
                      <template v-for="subItem1 in item.subItems">
                        <li
                            v-if="subItem1.subItems"
                            class="nav-item"
                            :key="subItem1.id"
                        >
                          <b-link
                              :href="`#sidebar-${subItem1.id}`"
                              class="nav-link"
                              data-bs-toggle="collapse"
                              role="button"
                              aria-expanded="false"
                              :aria-controls="`sidebar-${subItem1.id}`"
                              :data-key="`t-${subItem1.id}`"
                              style="white-space: nowrap"
                          >
                            {{ $t(subItem1.label) }}
                          </b-link>
                          <div
                              class="collapse menu-dropdown"
                              :id="`sidebar-${subItem1.id}`"
                          >
                            <ul class="nav nav-sm flex-column">
                              <li
                                  v-for="(subItem2, index) in subItem1.subItems"
                                  class="nav-item"
                                  :key="index"
                              >
                                <router-link
                                    :to="subItem2.link"
                                    class="nav-link"
                                    :data-key="`t-${subItem1.id}`"
                                    style="white-space: nowrap"
                                >
                                  {{ $t(subItem2.label) }}
                                </router-link>
                              </li>
                            </ul>
                          </div>
                        </li>
                        <li v-else class="nav-item" :key="subItem1.id">
                          <b-link
                              :to="subItem1.link"
                              class="nav-link"
                              style="white-space: nowrap"
                          >
                            {{ $t(subItem1.label) }}
                          </b-link>
                        </li>
                      </template>
                    </ul>
                  </div>
                </li>
                <li v-else class="nav-item" :key="item.id">
                  <router-link
                      :to="item.link"
                      class="nav-link"
                      :data-key="`t-${item.id}`"
                      style="white-space: nowrap"
                  >
                    <i :class="item.icon&&item.icon"></i>
                    <span >{{ $t(item.label) }}</span>
                  </router-link>
                </li>
              </template>
            </ul>
          </b-container>
          <!-- Sidebar -->
        </div>
        <!-- Left Sidebar End -->
        <!-- Vertical Overlay-->
        <div class="vertical-overlay"></div>
      </div>
      <!-- ============================================================== -->
      <!-- Start Page Content here -->
      <!-- ============================================================== -->

      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <b-container fluid>
            <!-- <div data-simplebar data-simplebar-auto-hide="true" data-simplebar-track="primary" style="max-height: 1000px; overflow-x: hidden;"> -->
            <slot />
            <!-- </div> -->
          </b-container>
        </div>
        <Footer />
      </div>
      <RightBar />
    </div>
  </div>
</template>
